import { imageUrl } from './api';
import { BackendPlan } from './plans';
//import { NEXT_YEAR } from './config';

export const heatmapImage = new Map<string, string>([
    ['IADV', 'blue-adv-heat-legend-large.png'],
    // ['ISAV', '../images/blueAdvantage.png'],
    ['ILOW', 'blue-value-heat.png'],
    ['ITIR', 'blueSelect.png'],
    ['WFBH', 'blue-local-wakeforest-heat.png'],
    ['ICLT', 'blue-local-atrium-heat.png'],
    ['BCAR', 'blue-care-heat-map.png'],
    ['BHNV', 'blue-home-novant-health.png'],
    ['BHOM', 'blue-home-unc-health-alliance-heat.png'],
    ['ICON', 'blue-home-cone.png'],
]);
export const heatmapImage2026 = new Map<string, string>([
    ['IADV', 'blue-adv-heat-legend-large-2026.png'],
    // ['ISAV', '../images/blueAdvantage.png'],
    ['ILOW', 'blue-value-heat-2026.png'],
    ['ITIR', 'blueSelect.png'],
    ['WFBH', 'blue-local-wakeforest-heat.png'],
    ['ICLT', 'blue-local-atrium-heat-2026.png'],
    ['BCAR', 'blue-care-heat-map-2026.png'],
    ['BHNV', 'blue-home-novant-health-2026.png'],
    ['BHOM', 'blue-home-unc-health-alliance-heat-2026.png'],
    ['ICON', 'blue-home-cone.png'],
]);

export function getHeatmapImgSrc(plan: BackendPlan) {
    // const filename: string | undefined;
    // if (plan.productYear === `${NEXT_YEAR}`) {
    const filename = heatmapImage2026.get(plan.productLineCode);
    // } else {
    // const filename = heatmapImage.get(plan.productLineCode);
    // }
    if (!filename) return '';
    return `${imageUrl}/${filename}`;
}

const heatmapNetworkName = new Map<string, string>([
    ['IADV', 'Blue Advantage'],
    ['WFBH', 'Blue Local with Wake Forrest Baptist Health'],
    ['ICLT', 'Blue Local with Atrium Health'],
    ['BCAR', 'Blue Care'],
    ['ILOW', 'Blue Value'],
    ['BHNV', 'Blue Home Novant Health'],
    ['BHOM', 'Blue Home UNC Health Alliance'],
    ['ICON', 'Blue Home Cone Health'],
]);

export function getHeatmapTooltip(plan: BackendPlan) {
    // if (plan.productLineCode === 'ITIR') {
    //     return 'The blue shaded are on the map represents network coverage for the Blue Select network. Dark blue represents tier 1 providers and light blue represents tier 2 providers. To find out if a doctor or facility is in network, click on "Doctor". For a list of all counties available in this network go to view plan details';
    // }
    const networkName = heatmapNetworkName.get(plan.productLineCode);
    return `The blue shaded area on the map represents network coverage for the ${networkName} network. To find out if a doctor or facility is in network, click on "Doctor". For a list of all counties available in this network go to view plan details.`;
}
